export default __webpack_public_path__ + "static/media/page3.89c42862.webp";